module.exports = __webpack_public_path__ + "img/profile.1b8be325.svg";